import { render, staticRenderFns } from "./last-orders.vue?vue&type=template&id=d2e91de4&scoped=true&"
import script from "./last-orders.vue?vue&type=script&lang=js&"
export * from "./last-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e91de4",
  null
  
)

export default component.exports